import { css } from "@emotion/css"

import COLOR_CODE from "../../../constant/color"
import Z_INDEX from "../../../constant/zIndex"

const DisabledOverlay = () => {
  return <div className={style} />
}

export default DisabledOverlay

const style = css`
  position: absolute;
  top: 0;
  left: 0;
  z-index: ${Z_INDEX.DISABLED_OVERLAY};
  width: 100%;
  height: 100%;
  background-color: ${COLOR_CODE.LIGHT_BLACK};
  opacity: 0.3;
`
